import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  TipoBono,
  tipoBonoEntradaPlantilla,
  TipoBonoTaxonomia,
} from "@sharedV11/classes/entradas-y-promociones/tipo-entrada/tipobono";
import { DialogoPopUp } from "@sharedV11/components/alert/dialog/popup.service";
import { TableInteractiveComponent } from "@sharedV11/components/tables/table-interactive/table-interactive.component";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { ComplementosV11Service } from "@sharedV11/services/components/entradas-y-promociones/complementos-v11/complementos-v11.service";
import { EntryTypeService } from "@sharedV11/services/components/entradas-y-promociones/entry-type/entry-type.service";
import { BonoTypeService } from "@sharedV11/services/components/entradas-y-promociones/tipobono/bono-type.service";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { TraerDatosListaFilters } from "@sharedV11/models";
import { DualListComponent } from "angular-dual-listbox";
import moment from "moment";
import { forkJoin, Subscription } from "rxjs";
import { take } from "rxjs/operators";

/**
 * Taxonomía (Tipos de promoción) — contrato funcional
 * ---------------------------------------------------------------------------
 * La sección UI "Taxonomía" y la obligatoriedad de sus campos dependen **solo**
 * de `AppConfigJsonCustommanConfigOtros.Taxonomia === 1` en la respuesta de
 * `{URLBASE}/Configuracion/GetAppConfig` (se persiste en `localStorage` como
 * clave `"Taxonomia"` en login y redirect-ms).
 *
 * - Si **Taxonomia ≠ 1** (no se muestra el bloque): **no** se añaden al formulario
 *   los controles `taxo*`, **no** se exige rellenar taxonomía en `submit`, y **no**
 *   deben aparecer etiquetas de taxonomía en los avisos de campos obligatorios.
 * - Si **Taxonomia = 1** (se muestra): **toda** la configuración del bloque es
 *   obligatoria: Centro coste TX, Tipo precio TX, Canal ventas TX y **Nivel 1 TX**.
 *   Los niveles 2…N son obligatorios **solo cuando existen** en el formulario
 *   (cascada según el nivel anterior), no todos a la vez de forma fija.
 * - **Cuenta visitante** (solo informativo): visible en la hoja de la cascada
 *   (sin nivel siguiente: `TieneSucesor` ≠ 1) y `CuentaVisitante` numérico > -1;
 *   texto «No» / «Sí» para 0 / 1. La API puede omitir `TieneSucesor: 0` en hojas.
 * ---------------------------------------------------------------------------
 */

/** Ítem devuelto por Customan/GetTXItemVentasSegunNivel */
interface TxItemVentasNivel {
  NivelNombre: string;
  TieneSucesor: string | number;
  TXItemVentasId: string | number;
  RevenueCategory?: string;
  CuentaVisitante?: string | number;
}

@Component({
  selector: "app-edit-tipobono",
  templateUrl: "./edit-tipobono.component.html",
  styleUrls: ["./edit-tipobono.component.scss"],
})
export class EditTipoBonoComponent implements OnInit {


  loading = true;
  //loaded = false;
  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;
  @ViewChild("ti_tipoBono") ti_tipoBono: TableInteractiveComponent;
  @ViewChild("taxoTaxonomiaNivelesAnchor")
  taxoTaxonomiaNivelesAnchor?: ElementRef<HTMLElement>;
  @ViewChild("taxoTaxonomiaInfoFooter")
  taxoTaxonomiaInfoFooter?: ElementRef<HTMLElement>;
  //dataSourceTarifaPromocionEntrada: MatTableDataSource<tipoBonoEntradaPlantilla>;

  translation;

  editorRegistroForm: FormGroup;
  printPromotionFormSub: Subscription;
  printTicketFormSub: Subscription;

  bonoType: TipoBono = null;
  GrupoMotivosId: any;
  gruposTipoBono: any;
  gruposTiposProductos: any;
  gruposAsociados: any;
  tiposvisitas: any;
  tiposnivel: any;
  tiposcontrol: any;
  categoriaDatos: any;
  TEDatos: any;
  tiposEntrada: any;

  /////
  permiteBorrar: boolean = true;
  elementosBorrados: string[] = [];
  promocionEntradaFormGroup: FormArray = this.formBuilder.array([]);
  tiposBonoEntrada: tipoBonoEntradaPlantilla[];

  formchanges: boolean = false;
  columnsToDisplayTarifaEntrada: string[];

  tablavalida;
  tiposBotoneraEntrada;
  listaCanales: any[] = [];

  /** `true` solo si GetAppConfig → AppConfigJsonCustommanConfigOtros.Taxonomia = 1 (vía localStorage). */
  mostrarTaxonomia = false;
  mostrarCanalesPorConfig = false;
  mostrarCentrosPorConfig = false;

  listaTxCentroCoste: any[] = [];
  listaTxTipoPrecio: any[] = [];
  listaTxCanalVentas: any[] = [];

  taxoNivelOpciones: TxItemVentasNivel[][] = [];
  taxoNivelSeleccionMeta: (TxItemVentasNivel | null)[] = [];
  private taxoTXAlojamientoIdPendiente: string | number | null = null;
  private readonly maxTaxoNiveles = 7;
  private taxoIgnorarCambioNivel = false;

  /**
   * Valores informativos del `Taxonomia` recibido al cargar el tipo (Customan devuelve
   * RevenueCategory / CuentaVisitante aquí aunque GetTXItemVentasSegunNivel no los traiga).
   * Se fusionan en la hoja solo si el TXItemVentasId coincide.
   */
  private taxoSnapshotInformacion: {
    txItemVentasId: string;
    cuentaVisitante?: string | number;
    revenueCategory?: string;
  } | null = null;

  /** `true` si la ruta actual vino de TXNivel1…7 del payload (fusionar info guardada aunque el id de hoja difiera). */
  private taxoHydratedFromPayloadLevels = false;

  /** Mientras se resuelven en paralelo las listas de niveles (evita ver 1…N filas apareciendo en secuencia). */
  taxoMontandoNiveles = false;

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  //centros

  // Complementos
  complementosDisponibles: any[] = [];
  opcionesComplemento: Array<{ Nombre: string; pkId: string }> = [];

  // FormArray de complementos
  get complementos(): FormArray {
    return this.editorRegistroForm.get("Complementos") as FormArray;
  }

  private markFormAsInvalid: Function;

  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };
  eltope: number = 0;

  /////
  constructor(
    private translator: Translator,
    private formBuilder: FormBuilder,
    private _cds: ChangeDetectorRef,
    private panelService: PanelService,
    private servicioAPI: ConectarApiService,
    private BonoTypeService: BonoTypeService,
    public global: GlobalService,
    public dialog: MatDialog,
    private snackvar_service: SnackbarInfoService,
    private alertaServicio: AlertService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    private entryTypeService: EntryTypeService,
    private complementosService: ComplementosV11Service
  ) {}

  ngAfterViewInit() {
    //setTimeout(function() {this.loaded=true;this._cds.detectChanges()},10000)
  }

  async ngOnInit(): Promise<void> {
    this.alertaServicio.limpiar();
    this.loadCentros();
    this.translation = this.translator.GetTranslations();
    
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.opcionesComplemento = [
      {
        Nombre:
          this.translation.Desglosar ||
          this.translation.Desglose ||
          "Desglose",
        pkId: "1",
      },
      {
        Nombre: this.translation.Imprimir,
        pkId: "2",
      },
    ];

    this.columnsToDisplayTarifaEntrada = [
      "Acciones",
      "NombreTipoEntrada",
      "iNumEntradas",
      "rPorcentaje",
      "dtFechaInicio",
      "dtFechaFin",
    ];

    this.generateForm();

    // Inicializa complementos com uma linha vazia no modo inserção
    if (!this.pkId || this.pkId === "0") {
      this.addComplemento();
    }

    this.printPromotionFormSub = this.editorRegistroForm.get("bImprimirPromo").valueChanges.subscribe((value) => {
      console.log('bImprimirPromo', value);
      this.onChangesPrintPromotionCheck(value);
    });

    this.printTicketFormSub = this.editorRegistroForm.get("bImprimirTicket").valueChanges.subscribe((value) => {
      console.log('bImprimirTicket', value);
      this.onChangesPrintTicketCheck(value);
    });

    this.cargarDatos();
    this.cargarTiposControl();
    this.cargarBotonera();
    this.cargarComplementos();
    if (this.mostrarTaxonomia) {
      this.cargarListasTaxonomiaEstaticas();
    }
  }

  cargarComplementos() {
    const paginator = {
      page: 1,
      pagelements: 100,
      orderby: "pkId",
      ordertype: "ASC",
    };

    this.complementosService.getComplementos(paginator, []).subscribe(
      (data) => {
        const lista =
          data?.DatosResult?.Lista ??
          data?.DatosResult?.lista ??
          data?.DatosResult?.LIsta ??
          data?.DatosResult?.LISTA ??
          [];
        this.complementosDisponibles = Array.isArray(lista) ? [...lista] : [];
        this._cds.detectChanges();
      },
      () => {
        this.complementosDisponibles = [];
        this._cds.detectChanges();
      }
    );
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  onChangesPrintPromotionCheck(value) {
    if (!value) {
      this.editorRegistroForm.get("bImprimirTicket").setValue(value);
    }
  }

  onChangesPrintTicketCheck(value) {
    const codigoCtrl = this.editorRegistroForm.get("CodigoBarras");
    const conjuntaCtrl = this.editorRegistroForm.get("bImpresionConjunta");

    if (!codigoCtrl || !conjuntaCtrl) {
      return;
    }

    if (!value) {
      codigoCtrl.disable({ emitEvent: false });
      conjuntaCtrl.disable({ emitEvent: false });
      codigoCtrl.setValue(false, { emitEvent: false });
      conjuntaCtrl.setValue(false, { emitEvent: false });
    } else {
      codigoCtrl.enable({ emitEvent: false });
      conjuntaCtrl.enable({ emitEvent: false });
    }
  }

  save(cerrarpanel?) {
    this.loading = false;
    this.panelService.setDiscardChanges(true);
    this.panelService.setSavePanel(cerrarpanel);
    document.getElementById("eltope").scrollTop = this.eltope;
  }

  destroy() {
    if (this.printPromotionFormSub) this.printPromotionFormSub.unsubscribe();
    if (this.printTicketFormSub) this.printTicketFormSub.unsubscribe();
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  discard() {
    this.setValuesForm(this.bonoType);
  }

  submit(cerrarpanel: boolean = true) {
    this.alertaServicio.limpiar();
    var fechasvacias = false;
    this.eltope = document.getElementById("eltope").scrollTop;

    var porcentajeTotal = 0;
    this.ti_tipoBono.dataSource.data.forEach((item) => {
      if (item.rPorcentaje == "") item.rPorcentaje = 0;
      if (item) porcentajeTotal += parseFloat(item.rPorcentaje);
      if (item.dtFechaFin == "" || item.dtFechaInicio == "")
        fechasvacias = true;
    });

    this.editorRegistroForm.markAllAsTouched();
    // Taxonomía obligatoria solo si GetAppConfig mostró el bloque (mostrarTaxonomia).
    if (this.mostrarTaxonomia && !this.validarTaxonomiaParaGuardar()) {
      const msg =
        this.translation?.FaltanCamposObligatorios ||
        "Faltan campos obligatorios";
      this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
      return;
    }
    const missing = this.getMissingRequiredFieldsLabels();
    if (
      !this.ti_tipoBono.dataSource.data ||
      this.ti_tipoBono.dataSource.data.length === 0
    ) {
      missing.push(this.translation?.Entradas || "Entradas");
    }

    if (missing.length > 0 || this.editorRegistroForm.invalid) {
      const base =
        this.translation?.FaltanCamposObligatorios || "Faltan Campos Obligatorios";
      const msg = missing.length > 0 ? `${base}: ${missing.join(", ")}` : base;
      this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
      return;
    }

    if (!fechasvacias && porcentajeTotal > 0 && porcentajeTotal === 100) {
      if (
        this.ti_tipoBono.dataSource.data &&
        this.ti_tipoBono.dataSource.data.length > 0
      ) {

        if (this.iGrupoId.value == "") 
          this.markFormAsInvalid("answer","Campo Requerido");
        
        this.editorRegistroForm.markAllAsTouched();

        if (!this.isComplementosSectionValid()) {
          const msg =
            this.translation.CampoComplementosObligatorio ||
            `${this.translation.Complementos || "Complementos"}: ${
              this.translation.CampoObligatorio || "Campo obligatorio"
            }`;
          this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
          return;
        }

        // let client:Cliente=this.editorRegistroForm.value;

        if (this.editorRegistroForm.valid) {
          //this.editorRegistroForm.get("GrupoMotivoId").setValue(this.editorRegistroForm.get("GrupoMotivoId").value)
          //this.bonoType = this.editorRegistroForm.value;
          //this.bonoType["grupoMotivoId"] = this.editorRegistroForm.get("GrupoMotivoId").value;

          this.editorRegistroForm.markAllAsTouched();
          let tipoBono: TipoBono = this.editorRegistroForm.value;
          //tipoBono["TipoBonoEntadas"]=this.ti_tipoBono.dataSource.data;

          this.manageApi(tipoBono, this.mode, cerrarpanel);
        }
      } else {
        this.snackvar_service.openSnackBar(
          this.translation.Necesitaalmenosunaentrada,
          "",
          "red-snackbar"
        );
      }
    } else {
      const dialogRef = this.dialog.open(DialogoPopUp, {
        width: "250px",
        data: {
          titulo: this.translation.PorcentajeIncorrecto,
          texto: this.translation.ElPorcentajeHaDeSerDelCienPorciento,
          ok: this.translation.Confirmar,
        },
      });
    }
  }

  private getMissingRequiredFieldsLabels(): string[] {
    const labels: string[] = [];
    const labelMap: { [key: string]: string } = {
      chNombrePromo: this.translation?.Nombre,
      iGrupoId: this.translation?.iGrupoId,
      taxoCentroCosteId:
        this.translation?.CentroCosteTX || "Centro Coste TX",
      taxoTipoPrecioId: this.translation?.TipoPrecioTX || "Tipo Precio TX",
      taxoCanalVentasId:
        this.translation?.CanalVentasTX || "Canal Ventas TX",
    };

    if (this.editorRegistroForm && this.editorRegistroForm.controls) {
      Object.keys(this.editorRegistroForm.controls).forEach((name) => {
        // Sin bloque Taxonomía en UI (GetAppConfig), no debe listarse obligatoriedad taxo*.
        if (
          !this.mostrarTaxonomia &&
          (name === "taxoCentroCosteId" ||
            name === "taxoTipoPrecioId" ||
            name === "taxoCanalVentasId" ||
            name === "taxoNiveles")
        ) {
          return;
        }
        const ctrl = this.editorRegistroForm.get(name);
        if (ctrl instanceof FormControl && ctrl.errors?.required) {
          labels.push(labelMap[name] || this.translation?.[name] || name);
        }
        if (
          this.mostrarTaxonomia &&
          name === "taxoNiveles" &&
          ctrl instanceof FormArray
        ) {
          ctrl.controls.forEach((c, idx) => {
            if (c instanceof FormControl && c.errors?.required) {
              const base = this.translation?.NivelTX || "Nivel";
              labels.push(`${base} ${idx + 1} TX`);
            }
          });
        }
      });
    }

    return Array.from(new Set(labels)).filter(
      (x) => !!x && String(x).trim() !== ""
    );
  }

  get f() {
    return this.editorRegistroForm.controls;
  } //Editor

  get taxoNiveles(): FormArray {
    return this.editorRegistroForm?.get("taxoNiveles") as FormArray;
  }

  get taxoMostrarRevenueCategory(): boolean {
    const leaf = this.getTaxoItemHojaParaVista();
    if (!leaf) {
      return false;
    }
    const rc = leaf.RevenueCategory;
    return rc != null && String(rc).trim() !== "";
  }

  get taxoRevenueCategoryTexto(): string {
    const leaf = this.getTaxoItemHojaParaVista();
    return leaf ? String(leaf.RevenueCategory ?? "") : "";
  }

  get taxoMostrarCuentaVisitante(): boolean {
    const leaf = this.getTaxoItemHojaParaVista();
    if (!leaf) {
      return false;
    }
    const n = this.taxoLeerCuentaVisitanteNumerico(leaf);
    return !Number.isNaN(n) && n > -1;
  }

  get taxoCuentaVisitanteTexto(): string {
    const leaf = this.getTaxoItemHojaParaVista();
    if (!leaf) {
      return "";
    }
    const n = this.taxoLeerCuentaVisitanteNumerico(leaf);
    if (n === 1) {
      return this.translation?.Si || "Sí";
    }
    if (n === 0) {
      return this.translation?.No || "No";
    }
    return String(leaf.CuentaVisitante ?? "");
  }
  get chTipoValidez() {
    return this.editorRegistroForm.get("chTipoValidez");
  }
  get iValidez() {
    return this.editorRegistroForm.get("iValidez");
  }
  get iGrupoId() {
    return this.editorRegistroForm.get("iGrupoId");
  }

  manageForm(pkId, mode) {
    //this.changeStatusClientCode(true)

    if (mode == "I") {
      this.bonoType = this.editorRegistroForm.value;
      this.taxoTXAlojamientoIdPendiente = null;
      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
      this.centrosAsignados = this.gsCentros.daTiposCentros(this.bonoType);
      this.loading = false;
      this.valuedChanged();
      //this.changeStatusClientCode(false)
    }

    if (pkId != null) {
      // this.findClient(pkId)
      this.findBonoType(pkId);
    }
  }

  findBonoType(pkId) {
    let paginator = {
      page: 1,
      pagelements: 10,
      orderby: "pkId",
      ordertype: "ASC",
    };
    let filters = [{ name: "pkId", value: this.pkId, translation: "", db: "" }];
    this.BonoTypeService.getTiposBono(paginator, filters).subscribe(
      (response) => {
        if (response.DatosResult != null) {
          const lista = response?.DatosResult?.lista ?? response?.DatosResult?.Lista ?? [];
          this.bonoType = Array.isArray(lista) && lista.length > 0 ? lista[0] : null;
          if (!this.bonoType) {
            this.destroy();
            return;
          }
          const taxonomiaGuardada = this.bonoType.Taxonomia as TipoBonoTaxonomia | undefined;
          let CentrosIds = this.bonoType.CentrosIds;
          this.setValuesForm(this.bonoType);
          this.loadComplementosFromTipoBono(this.bonoType);
          //this.dataSourceTarifaPromocionEntrada = new MatTableDataSource(this.bonoType.TipoBonoEntadas);
          this.bonoType = this.editorRegistroForm.value;
          this.bonoType.CentrosIds = CentrosIds;
          this.valuedChanged();
          this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
          this.centrosAsignados = this.gsCentros.daTiposCentros(this.bonoType);
          this.loading = false;
          if (this.mostrarTaxonomia) {
            this.taxoTXAlojamientoIdPendiente =
              taxonomiaGuardada?.TXAlojamientoId ?? null;
            this.taxoEstablecerSnapshotInformacionTaxonomia(taxonomiaGuardada);
            const rutaDesdePayload = this.leerRutaTaxonomiaDesdePayload(
              taxonomiaGuardada as TipoBonoTaxonomia | undefined
            );
            if (rutaDesdePayload.length > 0) {
              this.hidratarTaxonomiaNivelesDesdeRuta(rutaDesdePayload).then(() =>
                this._cds.detectChanges()
              );
            } else {
              const txId = taxonomiaGuardada?.TXItemVentasId;
              const txIdStr = txId != null ? String(txId) : "";
              if (txIdStr !== "" && txIdStr !== "0") {
                this.hidratarTaxonomiaNivelesDesdeTxItemId(txIdStr).then(() =>
                  this._cds.detectChanges()
                );
              } else {
                this.reiniciarTaxonomiaNivelesDesdeCero();
              }
            }
          }
        } else {
          this.destroy();
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  setEntradasDataTable() {
    //this.bonoType.TipoBonoEntadas = [];
    this.bonoType.Entradas = [];

    this.ti_tipoBono.dataSource.data.forEach((element, i) => {
      //if (element instanceof FormGroup) {
      let tipoBono = new tipoBonoEntradaPlantilla();
      if (element.pkId && element.pkId != "0") tipoBono.pkId = element.pkId;
      else tipoBono.pkId = "0";
      tipoBono.iTipoEntradaId = element.TipoEntradaId;
      tipoBono.NombreTipoEntrada = element.NombreTipoEntrada;
      tipoBono.iNumEntradas = element.iNumEntradas;
      // tipoBono.dtFechaInicio = this.fechaFrontToFechaApiTable(
      //   element.dtFechaInicio.value.format("DD/MM/YYYY")
      // );
      // tipoBono.dtFechaFin = this.fechaFrontToFechaApiTable(
      //   element.dtFechaFin.value.format("DD/MM/YYYY")
      // );

      let hoy:string = moment().format("DD/MM/YYYY").toString();
      tipoBono.dtFechaInicio = this.fechaFrontToFechaApiTable(hoy);
      tipoBono.dtFechaFin = this.fechaFrontToFechaApiTable(hoy);
      
      if (element.rPorcentaje == "") tipoBono.rPorcentaje = "0";
      else tipoBono.rPorcentaje = element.rPorcentaje;
      tipoBono.iTipoBonoEntradasId = element.iTipoBonoEntradasId;
      tipoBono.iTipoBonoId = this.bonoType.pkId;
      //this.bonoType.TipoBonoEntadas.push(tipoBono);
      this.bonoType.Entradas.push(tipoBono);
      //}
    });
  }

  /** 0 (número) ou "0" (string) = sem informação, como vazio */
  private isCantidadEmpty(cant: unknown): boolean {
    if (cant === undefined || cant === null || cant === "") return true;
    if (cant === 0 || cant === "0") return true;
    return false;
  }

  hasComplementoRowData(comp: any): boolean {
    const value = comp?.value || {};
    return !!(
      (value.ComplementoId && value.ComplementoId !== "") ||
      (value.Opcion && value.Opcion !== "") ||
      !this.isCantidadEmpty(value.Cantidad)
    );
  }

  private isComplementoRowEmpty(row: {
    ComplementoId?: string;
    Opcion?: string;
    Cantidad?: unknown;
  }): boolean {
    return (
      (!row.ComplementoId || row.ComplementoId === "") &&
      (!row.Opcion || row.Opcion === "") &&
      this.isCantidadEmpty(row.Cantidad)
    );
  }

  buildComplementosForRequest(): Array<{
    ComplementoId: string;
    Opcion: string;
    Cantidad: string;
  }> {
    if (!this.complementos || this.complementos.length === 0) {
      return [];
    }

    const result: Array<{
      ComplementoId: string;
      Opcion: string;
      Cantidad: string;
    }> = [];

    this.complementos.controls.forEach((ctrl) => {
      const value = ctrl.value || {};
      if (!this.isComplementoRowEmpty(value)) {
        result.push({
          ComplementoId: value.ComplementoId,
          Opcion: value.Opcion,
          Cantidad: value.Cantidad,
        });
      }
    });

    return result;
  }

  onComplementoInputClose(event: {
    name: string;
    value: string;
    methods?: any;
  }): void {
    if (!event || !event.name) {
      return;
    }

    const parts = event.name.split("_");
    if (parts.length !== 2) {
      return;
    }

    const field = parts[0];
    const index = parseInt(parts[1], 10);
    if (isNaN(index) || index < 0 || index >= this.complementos.length) {
      return;
    }

    const row = this.complementos.at(index) as FormGroup;
    if (!row) {
      return;
    }

    const rawValue = event.value;
    const value = rawValue === "-1" ? "" : rawValue;

    switch (field) {
      case "ComplementoId":
        if (event.methods) {
          this.complementoMethods[index] = event.methods;
        }
        row.get("ComplementoId")?.setValue(value);
        break;
      case "Opcion":
        if (event.methods) {
          this.opcionMethods[index] = event.methods;
        }
        row.get("Opcion")?.setValue(value);
        break;
      default:
        break;
    }
  }

  validateEntradas(promocionEntradaFormGroup) {
    let ret = true;

    if (promocionEntradaFormGroup)
      promocionEntradaFormGroup.controls.forEach((element) => {
        if (
          element instanceof FormGroup &&
          element.value["iTipoEntradaId"] == ""
        )
          ret = false;
        if (element instanceof FormGroup && element.value["iNumEntradas"] == "")
          ret = false;
        if (
          element instanceof FormGroup &&
          element.value["dtFechaInicio"] == ""
        )
          ret = false;
        if (element instanceof FormGroup && element.value["dtFechaFin"] == "")
          ret = false;
      });
    return ret;
  }

  complementoMethods: { [index: number]: any } = {};
  opcionMethods: { [index: number]: any } = {};

  onComplementoGetMethods(event: { methods?: any }, index: number): void {
    if (event && event.methods) {
      this.complementoMethods[index] = event.methods;
    }
  }

  onOpcionGetMethods(event: { methods?: any }, index: number): void {
    if (event && event.methods) {
      this.opcionMethods[index] = event.methods;
    }
  }

  private isComplementosSectionValid(): boolean {
    if (!this.complementos || this.complementos.length === 0) {
      return true; 
    }

    let hasAny = false;
    let allValid = true;

    this.complementos.controls.forEach((ctrl) => {
      const value = ctrl.value || {};
      const empty =
        (!value.ComplementoId || value.ComplementoId === "") &&
        (!value.Opcion || value.Opcion === "") &&
        this.isCantidadEmpty(value.Cantidad);

      if (!empty) {
        hasAny = true;
        if ((ctrl as FormGroup).invalid) {
          allValid = false;
        }
      }
    });

    return !hasAny || allValid;
  }
  private updateComplementoRowValidators(group: FormGroup): void {
    const value = group.value || {};
    const hasData =
      (value.ComplementoId && value.ComplementoId !== "") ||
      (value.Opcion && value.Opcion !== "") ||
      !this.isCantidadEmpty(value.Cantidad);

    const complCtrl = group.get("ComplementoId");
    const opcionCtrl = group.get("Opcion");
    const cantCtrl = group.get("Cantidad");

    if (hasData) {
      complCtrl?.setValidators([Validators.required]);
      opcionCtrl?.setValidators([Validators.required]);
      cantCtrl?.setValidators([
        Validators.required,
        Validators.pattern("^[0-9]+$"),
        Validators.min(1),
        Validators.maxLength(5),
      ]);
    } else {
      complCtrl?.clearValidators();
      opcionCtrl?.clearValidators();
      // Quando linha vazia: não exigir min(1) - "0" é válido (usuário não adicionou nada)
      cantCtrl?.setValidators([
        Validators.pattern("^[0-9]+$"),
        Validators.maxLength(5),
      ]);
    }
    complCtrl?.updateValueAndValidity({ emitEvent: false });
    opcionCtrl?.updateValueAndValidity({ emitEvent: false });
    cantCtrl?.updateValueAndValidity({ emitEvent: false });
  }

  addComplemento(data?: {
    ComplementoId?: string;
    Opcion?: string;
    Cantidad?: string;
  }) {
    const hasData = !!(
      (data?.ComplementoId && data.ComplementoId !== "") ||
      (data?.Opcion && data.Opcion !== "") ||
      !this.isCantidadEmpty(data?.Cantidad)
    );

    const group = this.formBuilder.group({
      ComplementoId: [
        data?.ComplementoId ?? "",
        hasData ? Validators.required : [],
      ],
      Opcion: [data?.Opcion ?? "", hasData ? Validators.required : []],
      Cantidad: [
        data?.Cantidad ?? "0",
        hasData
          ? [
              Validators.required,
              Validators.pattern("^[0-9]+$"),
              Validators.min(1),
              Validators.maxLength(5),
            ]
          : [
              Validators.pattern("^[0-9]+$"),
              Validators.maxLength(5),
            ],
      ],
    });

    group.valueChanges.subscribe(() => {
      this.updateComplementoRowValidators(group);
    });

    this.complementos.push(group);
  }

  onComplementoCantidadInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const filtered = input.value.replace(/\D/g, "").slice(0, 5);
    if (filtered !== input.value) {
      const ctrl = this.complementos.at(index)?.get("Cantidad");
      ctrl?.setValue(filtered, { emitEvent: true });
    }
  }

  removeComplemento(index: number) {
    if (this.complementos.length > 1) {
      // Remove a linha selecionada
      this.complementos.removeAt(index);
    } else {
      const group = this.complementos.at(index) as FormGroup;
      if (group) {
        group.patchValue({
          ComplementoId: "",
          Opcion: "",
          Cantidad: "0",
        });
        group.markAsPristine();
        group.markAsUntouched();
      }

      const compleMethods = this.complementoMethods[index];
      if (compleMethods && typeof compleMethods.setManualValueForm === "function") {
        compleMethods.setManualValueForm("");
      }

      const opcMethods = this.opcionMethods[index];
      if (opcMethods && typeof opcMethods.setManualValueForm === "function") {
        opcMethods.setManualValueForm("");
      }
    }
  }

  resetComplementos() {
    const arr = this.complementos;
    if (!arr) return;
    while (arr.length > 0) {
      arr.removeAt(0);
    }
  }

  loadComplementosFromTipoBono(bonoType: TipoBono) {
    this.resetComplementos();
    if (!bonoType || !bonoType.Complementos || bonoType.Complementos.length === 0) {
      this.addComplemento();
      return;
    }

    bonoType.Complementos.forEach((c) => {
      this.addComplemento({
        ComplementoId: c.ComplementoId,
        Opcion: c.Opcion,
        Cantidad: c.Cantidad,
      });
    });
  }

  getComplementoDisplay(complementoId: string): string {
    if (!complementoId) {
      return this.translation?.Complementos || "";
    }
    const item = this.complementosDisponibles?.find(
      (c) => c.pkId === complementoId
    );
    return item ? item.Nombre : complementoId;
  }

  getOpcionDisplay(opcion: string): string {
    if (!opcion) {
      return this.translation?.Opciones || "";
    }
    if (opcion === "1") {
      return (
        this.translation?.Desglosar ||
        this.translation?.Desglose ||
        "Desglose"
      );
    }
    if (opcion === "2") {
      return this.translation?.Imprimir || "Imprimir";
    }
    return opcion;
  }
  insertDataInObj() {
    (this.bonoType.pkId = this.pkId ? this.pkId : "0"),
      (this.bonoType.CodigoBarras =
        this.global.aBooleano(this.bonoType.CodigoBarras) == true ? "1" : "0");
    this.bonoType.BarCodeInternet =
      this.global.aBooleano(this.bonoType.BarCodeInternet) == true ? "1" : "0";
    this.bonoType.bALaVenta =
      this.global.aBooleano(this.bonoType.bALaVenta) == true ? "1" : "0";
    this.bonoType.bImprimirPrecio =
      this.global.aBooleano(this.bonoType.bImprimirPrecio) == true ? "1" : "0";
    this.bonoType.bImprimirTicket =
      this.global.aBooleano(this.bonoType.bImprimirTicket) == true ? "1" : "0";

    this.bonoType.bImpresionConjunta =
      this.global.aBooleano(this.bonoType.bImpresionConjunta) == true
        ? "1"
        : "0";
    this.bonoType.bControlarAcceso =
      this.global.aBooleano(this.bonoType.bControlarAcceso) == true ? "1" : "0";

    //this.bonoType.chTeclaRapida = this.global.aBooleano(this.bonoType.chTeclaRapida)==true?"1":"0";
    this.bonoType.bImprimirPromo =
      this.global.aBooleano(this.bonoType.bImprimirPromo) == true ? "1" : "0";
  }
  manageApi(tipoBono: TipoBono, mode, cerrarpanel?) {
    this.bonoType = tipoBono;
    this.bonoType.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
      this.centrosAsignados
    );
    this.loading = true;
    this.insertDataInObj();
    //this.changeStatusClientCode(true)

    this.bonoType.siCodigoTipoControl = this.bonoType.siCodigoTipoControl ? this.bonoType.siCodigoTipoControl : null;

    // Complementos
    const complementosPayload = this.buildComplementosForRequest();
    this.bonoType.Complementos =
      complementosPayload && complementosPayload.length > 0
        ? complementosPayload
        : null;

    this.limpiarCamposFormularioTaxonomiaDelPayload(this.bonoType as any);
    if (this.mostrarTaxonomia) {
      this.bonoType.Taxonomia = this.buildTaxonomiaPayload();
    } else {
      this.bonoType.Taxonomia = null;
    }

    switch (mode) {
      case "I":
        this.bonoType.pkId = "0";
        this.bonoType.chTipoValidez = 'S'
        this.bonoType.iValidez = "0"
        this.setEntradasDataTable();
        this.insTipoBonos(this.bonoType, cerrarpanel);
        break;
      
      case "U":
        this.bonoType.chTipoValidez = 'S'
        this.bonoType.iValidez = "0"

        this.setEntradasDataTable();

        this.UpdTipoBonos(this.bonoType, cerrarpanel);
        break;
      
      case "D":
        this.mode = "I";
        this.bonoType.pkId = "0";
        this.bonoType.chTipoValidez = 'S'
        this.bonoType.iValidez = "0"

        //this.setDataSourceTarifasPromocionEntrada();
        this.setEntradasDataTable();
        //this.setEntradasData();
        this.bonoType.Entradas.map((entrada) => {
          entrada.pkId = "0";
        });
        this.insTipoBonos(this.bonoType, cerrarpanel);
        break;

      default:
        break;
    }
    //this.changeStatusClientCode(false)
  }

  insTipoBonos(tbono, cerrarpanel?) {
    //this.servicioAPI.insTipoBono(this.bonoType, this.mode).subscribe(response => {
    this.servicioAPI.insTipoBono(tbono, this.mode).subscribe(
      (response) => {
        //this.ti_tipoBono.reloadTable();
        this.nextWindow(response, cerrarpanel);
        //this.save();
        //this.destroy();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  UpdTipoBonos(tbono, cerrarpanel?) {
    this.servicioAPI.updTipoBono(this.bonoType, this.mode).subscribe(
      (response) => {
        if (response.DatosResult != null) {
          this.nextWindow(response, cerrarpanel);
        } else {
          this.snackvar_service.openSnackBar(
            response.Mensajes[0].DescripcionMensaje,
            "",
            "red-snackbar"
          );
          this.nextWindow(response, cerrarpanel);
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  nextWindow(response: any, cerrarpanel?) {
    if (response.Mensajes.length > 0) {
      response.Mensajes.forEach((element) => {
        this.snackvar_service.openSnackBar(
          element.DescripcionMensaje,
          "",
          "red-snackbar",
          element.CodigoMensaje
        );
      });
    } else {
      this.snackvar_service.openSnackBar(
        this.translation["MensajeSuccessSnackBar"],
        "",
        "green-snackbar"
      );
    }

    this.save(cerrarpanel);
    if (cerrarpanel && cerrarpanel == true) this.destroy();
  }

  existErrors() {
    return this.editorRegistroForm.get("pkId").errors ? true : false;
  }

  valuedChanged() {
    this.editorRegistroForm.valueChanges.subscribe((value) => {
      if (this.bonoType != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.bonoType)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  generateForm() {
    this.editorRegistroForm = this.formBuilder.group({
      chNombrePromo: ["", Validators.required],
      chCodigo: [""],
      chDescripcionNombre: [""],
      chTextoPantalla: [""],
      chTextoImpresion: [""],
      chTextoDisplay: [""],
      // chTipoValidez: ["", Validators.required],
      iGrupoId: ["", Validators.required],
      GrupoMotivoId: [""],
      iTipoProductoId: [""],
      iGrupoAsociadoId: [""],
      // iValidez: ["0", Validators.required],
      iTipoVisitaId: [""],
      iTipoNivelId: [""],
      iCategoriaId: [""],
      iTEDatosId: [""],
      bALaVenta: [false],
      bImprimirPromo: [false],
      bImprimirPrecio: [false],
      bImprimirTicket: [false],
      chTeclaRapida: [""],
      CodigoBarras: [false],
      BarCodeInternet: [false],
      bImpresionConjunta: [false],
      siCodigoTipoControl: [""],
      bControlarAcceso: [""],
      iNominar: ["0"],
      Entradas: this.promocionEntradaFormGroup,
      Complementos: this.formBuilder.array([]),
    });

    // Estado inicial dos controles dependentes de bImprimirTicket
    const initialTicket = this.editorRegistroForm.get("bImprimirTicket").value;
    this.onChangesPrintTicketCheck(initialTicket);

    const asociarCentrosCosteCanales = JSON.parse(
      localStorage.getItem("AsociarCentrosCosteCanales")
    );
    const ObligatorioCentrosDeCoste = JSON.parse(
      localStorage.getItem("ObligatorioCentrosDeCoste")
    );
    const ObligatorioCanalesEntradas = JSON.parse(
      localStorage.getItem("ObligatorioCanalesEntradas")
    );
    if (asociarCentrosCosteCanales == "1") {
      if (ObligatorioCentrosDeCoste == "1") {
        this.editorRegistroForm.addControl(
          "centroCosteId",
          new FormControl("", Validators.required)
        );
      } else {
        this.editorRegistroForm.addControl(
          "centroCosteId",
          new FormControl("")
        );
      }

      if (ObligatorioCanalesEntradas == "1") {
        this.editorRegistroForm.addControl(
          "canalId",
          new FormControl("", Validators.required)
        );
      } else {
        this.editorRegistroForm.addControl("canalId", new FormControl(""));
      }
    }

    let asociarCentrosParsed: any;
    try {
      asociarCentrosParsed = JSON.parse(
        localStorage.getItem("AsociarCentros") || '"0"'
      );
    } catch {
      asociarCentrosParsed = "0";
    }
    this.mostrarCentrosPorConfig =
      asociarCentrosParsed == "1" || asociarCentrosParsed === 1;

    this.mostrarCanalesPorConfig =
      asociarCentrosCosteCanales == "1" ||
      asociarCentrosCosteCanales === 1;

    // Taxonomía: misma fuente que GetAppConfig (localStorage "Taxonomia"). Si no es 1, no hay controles ni validación.
    this.mostrarTaxonomia = this.parseLocalStorageFlagOne(
      localStorage.getItem("Taxonomia")
    );

    if (this.mostrarTaxonomia) {
      this.editorRegistroForm.addControl(
        "taxoCentroCosteId",
        new FormControl("", Validators.required)
      );
      this.editorRegistroForm.addControl(
        "taxoTipoPrecioId",
        new FormControl("", Validators.required)
      );
      this.editorRegistroForm.addControl(
        "taxoCanalVentasId",
        new FormControl("", Validators.required)
      );
      this.editorRegistroForm.addControl(
        "taxoNiveles",
        this.formBuilder.array([
          this.formBuilder.control("", Validators.required),
        ])
      );
    }
  }

  private parseLocalStorageFlagOne(raw: string | null): boolean {
    if (raw === "1") {
      return true;
    }
    if (raw == null) {
      return false;
    }
    try {
      const t = JSON.parse(raw);
      return t === 1 || t === "1";
    } catch {
      return false;
    }
  }

  setValuesForm(bonoType) {
    this.f["chCodigo"].setValue(bonoType.chCodigo);
    this.f["chNombrePromo"].setValue(bonoType.chNombrePromo);
    this.f["chDescripcionNombre"].setValue(bonoType.chDescripcionNombre);
    this.f["chTextoPantalla"].setValue(bonoType.chTextoPantalla);
    this.f["chTextoImpresion"].setValue(bonoType.chTextoImpresion);
    this.f["chTextoDisplay"].setValue(bonoType.chTextoDisplay);
    // this.f["chTipoValidez"].setValue(bonoType.chTipoValidez);
    this.f["iGrupoId"].setValue(bonoType.iGrupoId);
    this.f["GrupoMotivoId"].setValue(bonoType.GrupoMotivoId);
    this.f["iTipoProductoId"].setValue(bonoType.iTipoProductoId);
    this.f["iGrupoAsociadoId"].setValue(bonoType.iGrupoAsociadoId);
    // this.f["iValidez"].setValue(bonoType.iValidez);
    this.f["iTipoVisitaId"].setValue(bonoType.iTipoVisitaId);
    this.f["iTipoNivelId"].setValue(bonoType.iTipoNivelId);
    this.f["iCategoriaId"].setValue(bonoType.iCategoriaId);
    this.f["iTEDatosId"].setValue(bonoType.iTEDatosId);
    this.f["bImprimirPromo"].setValue(
      this.global.aBooleano(bonoType.bImprimirPromo)
    );
    this.f["bALaVenta"].setValue(this.global.aBooleano(bonoType.bALaVenta));
    this.f["bImprimirPrecio"].setValue(
      this.global.aBooleano(bonoType.bImprimirPrecio)
    );
    this.f["bImprimirTicket"].setValue(
      this.global.aBooleano(bonoType.bImprimirTicket)
    );
    this.f["chTeclaRapida"].setValue(bonoType.chTeclaRapida);
    if (this.f["canalId"]) {
      this.f["canalId"].setValue(
        bonoType.canalId ?? bonoType.CanalId ?? ""
      );
    }
    this.f["CodigoBarras"].setValue(
      this.global.aBooleano(bonoType.CodigoBarras)
    );
    this.f["BarCodeInternet"].setValue(
      this.global.aBooleano(bonoType.BarCodeInternet)
    );
    this.f["bImpresionConjunta"].setValue(
      this.global.aBooleano(bonoType.bImpresionConjunta)
    );
    this.f["bControlarAcceso"].setValue(
      this.global.aBooleano(bonoType.bControlarAcceso)
    );
    this.f["iNominar"].setValue(
      bonoType.iNominar ? bonoType.iNominar.toString() : ""
    );
    this.f["siCodigoTipoControl"].setValue(bonoType.siCodigoTipoControl);

    if (this.mostrarTaxonomia && bonoType.Taxonomia && this.f["taxoCentroCosteId"]) {
      const t = bonoType.Taxonomia;
      this.f["taxoCentroCosteId"].setValue(
        t.TXCentroCosteId != null ? String(t.TXCentroCosteId) : ""
      );
      this.f["taxoTipoPrecioId"].setValue(
        t.TXTipoPrecioId != null ? String(t.TXTipoPrecioId) : ""
      );
      this.f["taxoCanalVentasId"].setValue(
        t.TXCanalVentasId != null ? String(t.TXCanalVentasId) : ""
      );
      this.sincronizarTaxonomiaTextoTresCamposDesdePkSiAplica();
    }

    bonoType.Entradas = [];

    //bonoType.TipoBonoEntadas.splice(1);
    this.tiposBonoEntrada = bonoType.TipoBonoEntadas;

    for (let i = 0; bonoType.TipoBonoEntadas.length > i; i++) {
      if (bonoType.TipoBonoEntadas[i].rPorcentaje == "") {
        bonoType.TipoBonoEntadas[i].rPorcentaje = "0";
      }
      //bonoType.Entradas.push(bonoType.TipoBonoEntadas[i]);
      var promocionEntradaFormControls = new FormGroup({
        pkId: new FormControl(bonoType.TipoBonoEntadas[i].pkId),
        iTipoBonoEntradasId: new FormControl(
          bonoType.TipoBonoEntadas[i].iTipoBonoEntradasId
        ),
        iTipoEntradaId: new FormControl(
          bonoType.TipoBonoEntadas[i].iTipoEntradaId
        ),
        NombreTipoEntrada: new FormControl(
          bonoType.TipoBonoEntadas[i].NombreTipoEntrada
        ),
        iNumEntradas: new FormControl(bonoType.TipoBonoEntadas[i].iNumEntradas),
        dtFechaInicio: new FormControl(
          this.fechaApiToFechaFront(bonoType.TipoBonoEntadas[i].dtFechaInicio)
        ),
        dtFechaFin: new FormControl(
          this.fechaApiToFechaFront(bonoType.TipoBonoEntadas[i].dtFechaFin)
        ),
        rPorcentaje: new FormControl(bonoType.TipoBonoEntadas[i].rPorcentaje),
      });

      this.promocionEntradaFormGroup.controls.push(
        promocionEntradaFormControls
      );
    }
    //this._cds.detectChanges();

    if (this.mode == "D") this.f["chCodigo"].setValue("");
    //this.setDataSourceTarifasPromocionEntrada();
  }

  async cargarTiposControl() {
    let resultado: boolean = false;

    await this.entryTypeService.getTiposControlAsync().then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposcontrol = data.DatosResult.customanTiposControl;
        } else {
          this.alertaServicio.error(data.Mensajes[0].DescripcionMensaje);
          resultado = false;
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
  }

  cargarCanales() {
    this.servicioAPI.ObtenerCustomanCanales().then(
      (data) => {
        if (data?.DatosResult) {
          this.listaCanales = data.DatosResult?.Lista || [];
          this.listaCanales.forEach((el) => {
            el.canalsubcanal = el.SubCanal || el.Subcanal || "";
          });
        } else {
          this.listaCanales = [];
        }
      },
      () => {
        this.listaCanales = [];
      }
    );
  }

  taxoListaPkId(row: any): string {
    if (!row) {
      return "";
    }
    const v = row.pkId ?? row.Id;
    return v != null ? String(v) : "";
  }

  private taxoResolverPkDesdeLista(
    lista: any[],
    valorCampo: unknown
  ): string | null {
    const v = String(valorCampo ?? "").trim();
    if (!v) {
      return null;
    }
    if (!lista?.length) {
      return null;
    }
    const porNombre = lista.find(
      (r) => (r.Nombre || "").trim() === v
    );
    if (porNombre) {
      const id = this.taxoListaPkId(porNombre);
      return id !== "" ? id : null;
    }
    const porId = lista.find((r) => this.taxoListaPkId(r) === v);
    if (!porId) {
      return null;
    }
    const id = this.taxoListaPkId(porId);
    return id !== "" ? id : null;
  }

  sincronizarTaxonomiaTextoTresCamposDesdePkSiAplica(): void {
    if (!this.mostrarTaxonomia || !this.f["taxoCentroCosteId"]) {
      return;
    }
    const sync = (ctrlName: string, lista: any[]) => {
      const cur = String(this.f[ctrlName].value ?? "").trim();
      if (!cur || !lista?.length) {
        return;
      }
      const matchId = lista.find((r) => this.taxoListaPkId(r) === cur);
      if (matchId?.Nombre != null) {
        this.f[ctrlName].setValue(String(matchId.Nombre), {
          emitEvent: false,
        });
      }
    };
    sync("taxoCentroCosteId", this.listaTxCentroCoste);
    sync("taxoTipoPrecioId", this.listaTxTipoPrecio);
    sync("taxoCanalVentasId", this.listaTxCanalVentas);
  }

  onTaxoListaCampoBlur(controlName: string, lista: any[]): void {
    const ctrl = this.f[controlName];
    if (!ctrl) {
      return;
    }
    let v = String(ctrl.value ?? "").trim();
    const matchId = lista?.find((r) => this.taxoListaPkId(r) === v);
    if (matchId?.Nombre != null) {
      v = String(matchId.Nombre);
    }
    ctrl.setValue(v, { emitEvent: false });
  }

  cargarListasTaxonomiaEstaticas(): void {
    forkJoin({
      cc: this.servicioAPI.TraerDatosListasAsync("txcentrocoste"),
      tp: this.servicioAPI.TraerDatosListasAsync("txtipoprecio"),
      cv: this.servicioAPI.TraerDatosListasAsync("txcanalventa", {
        NombreCampo: "activo",
        FiltroCampo: "1",
      } as unknown as TraerDatosListaFilters),
    }).subscribe({
      next: (res) => {
        this.listaTxCentroCoste = res.cc?.DatosListas ?? [];
        this.listaTxTipoPrecio = res.tp?.DatosListas ?? [];
        this.listaTxCanalVentas = res.cv?.DatosListas ?? [];
        this.sincronizarTaxonomiaTextoTresCamposDesdePkSiAplica();
        if (this.pkId == null || this.pkId === "0") {
          this.reiniciarTaxonomiaNivelesDesdeCero();
        }
        this._cds.detectChanges();
      },
      error: () => {
        this.listaTxCentroCoste = [];
        this.listaTxTipoPrecio = [];
        this.listaTxCanalVentas = [];
      },
    });
  }

  reiniciarTaxonomiaNivelesDesdeCero(): void {
    this.taxoHydratedFromPayloadLevels = false;
    this.taxoMontandoNiveles = false;
    const fa = this.taxoNiveles;
    if (!fa) {
      return;
    }
    while (fa.length) {
      fa.removeAt(0);
    }
    fa.push(this.formBuilder.control("", Validators.required));
    this.taxoNivelOpciones = [];
    this.taxoNivelSeleccionMeta = [];
    this.servicioAPI.getTXItemVentasSegunNivel(1, "").subscribe({
      next: (data) => {
        const list = this.mapListadoTxItems(data?.DatosResult?.Listado);
        this.taxoNivelOpciones = [list];
        this.taxoNivelSeleccionMeta = [null];
        this._cds.detectChanges();
      },
      error: () => {
        this.taxoNivelOpciones = [[]];
        this.taxoNivelSeleccionMeta = [null];
      },
    });
  }

  private scrollTaxoNivelesAnchorIntoView(): void {
    this._cds.detectChanges();
    const run = (): void => {
      const el = this.taxoTaxonomiaNivelesAnchor?.nativeElement;
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    };
    setTimeout(run, 0);
    setTimeout(run, 160);
  }

  /** Tras elegir hoja: mostrar Revenue / Cuenta visitante en viewport si aplica. */
  private scrollTaxoInfoFooterIntoView(): void {
    this._cds.detectChanges();
    const run = (): void => {
      const el = this.taxoTaxonomiaInfoFooter?.nativeElement;
      const mostrar =
        this.taxoMostrarRevenueCategory || this.taxoMostrarCuentaVisitante;
      if (el && mostrar) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    };
    setTimeout(run, 0);
    setTimeout(run, 120);
  }

  onTaxoNivelSelectionChange(index: number, nombre: string): void {
    if (this.taxoIgnorarCambioNivel) {
      return;
    }
    this.taxoHydratedFromPayloadLevels = false;
    const fa = this.taxoNiveles;
    if (!fa || !this.taxoNivelOpciones[index]) {
      return;
    }
    while (fa.length > index + 1) {
      fa.removeAt(fa.length - 1);
      this.taxoNivelOpciones.pop();
      this.taxoNivelSeleccionMeta.pop();
    }
    const list = this.taxoNivelOpciones[index];
    const item =
      list.find((x) => x.NivelNombre === nombre) || null;
    this.taxoNivelSeleccionMeta[index] = item;
    if (!nombre || !item || !this.tieneSucesorTaxo(item)) {
      this._cds.detectChanges();
      if (nombre && item && !this.tieneSucesorTaxo(item)) {
        this.scrollTaxoInfoFooterIntoView();
      }
      return;
    }
    const nextLevel = index + 2;
    if (nextLevel > this.maxTaxoNiveles) {
      return;
    }
    this.servicioAPI.getTXItemVentasSegunNivel(nextLevel, nombre).subscribe({
      next: (data) => {
        const nlist = this.mapListadoTxItems(data?.DatosResult?.Listado);
        if (!nlist.length) {
          this._cds.detectChanges();
          return;
        }
        this.taxoNivelOpciones.push(nlist);
        this.taxoNivelSeleccionMeta.push(null);
        fa.push(this.formBuilder.control("", Validators.required));
        this._cds.detectChanges();
        this.scrollTaxoNivelesAnchorIntoView();
      },
      error: () => this._cds.detectChanges(),
    });
  }

  private tieneSucesorTaxo(item: TxItemVentasNivel): boolean {
    const t = item?.TieneSucesor;
    return t === 1 || t === "1";
  }

  private taxoLeerCuentaVisitanteNumerico(leaf: TxItemVentasNivel): number {
    const v = leaf?.CuentaVisitante;
    if (v === undefined || v === null) {
      return NaN;
    }
    if (typeof v === "string" && v.trim() === "") {
      return NaN;
    }
    const n = Number(v);
    return n;
  }

  /**
   * Normaliza filas de Customan/GetTXItemVentasSegunNivel (variantes de nombre de propiedad).
   */
  private normalizarTxItemVentasNivel(raw: any): TxItemVentasNivel {
    if (!raw || typeof raw !== "object") {
      return { NivelNombre: "", TieneSucesor: "", TXItemVentasId: "" };
    }
    const base: TxItemVentasNivel = {
      NivelNombre: String(raw["NivelNombre"] ?? ""),
      TieneSucesor: raw["TieneSucesor"],
      TXItemVentasId: raw["TXItemVentasId"],
      RevenueCategory: raw["RevenueCategory"],
    };
    const cvKeys = [
      "CuentaVisitante",
      "cuentaVisitante",
      "Cuenta_Visitante",
      "Cuentavisitante",
      "Cuenta_visitante",
      "ICuentaVisitante",
      "iCuentaVisitante",
      "iCuentavisitante",
    ];
    for (const k of cvKeys) {
      if (!Object.prototype.hasOwnProperty.call(raw, k)) {
        continue;
      }
      const val = raw[k];
      if (val === undefined || val === null) {
        continue;
      }
      if (typeof val === "string" && val.trim() === "") {
        continue;
      }
      base.CuentaVisitante = val;
      break;
    }
    if (base.CuentaVisitante === undefined) {
      for (const key of Object.keys(raw)) {
        const norm = String(key).replace(/_/g, "").toLowerCase();
        if (norm !== "cuentavisitante" && norm !== "icuentavisitante") {
          continue;
        }
        const val = raw[key];
        if (val === undefined || val === null) {
          continue;
        }
        if (typeof val === "string" && val.trim() === "") {
          continue;
        }
        base.CuentaVisitante = val;
        break;
      }
    }
    return base;
  }

  private mapListadoTxItems(listado: any): TxItemVentasNivel[] {
    if (!Array.isArray(listado)) {
      return [];
    }
    return listado.map((row) => this.normalizarTxItemVentasNivel(row));
  }

  private getTaxoItemHoja(): TxItemVentasNivel | null {
    if (!this.taxoNivelSeleccionMeta.length) {
      return null;
    }
    const last =
      this.taxoNivelSeleccionMeta[this.taxoNivelSeleccionMeta.length - 1];
    if (!last || this.tieneSucesorTaxo(last)) {
      return null;
    }
    return last;
  }

  private taxoEstablecerSnapshotInformacionTaxonomia(
    t: TipoBonoTaxonomia | null | undefined
  ): void {
    if (!t) {
      this.taxoSnapshotInformacion = null;
      return;
    }
    const ext = t as Record<string, unknown>;
    const txId = String(t.TXItemVentasId ?? "").trim();
    const cv =
      ext["CuentaVisitante"] ??
      ext["cuentaVisitante"] ??
      ext["ICuentaVisitante"];
    const rc = ext["RevenueCategory"];
    let cuentaParsed: string | number | undefined;
    if (cv !== undefined && cv !== null) {
      if (typeof cv !== "string" || cv.trim() !== "") {
        cuentaParsed = cv as string | number;
      }
    }
    this.taxoSnapshotInformacion = {
      txItemVentasId: txId !== "" && txId !== "0" ? txId : "",
      cuentaVisitante: cuentaParsed,
      revenueCategory:
        rc != null && String(rc).trim() !== ""
          ? String(rc)
          : undefined,
    };
  }

  /** Ruta de nombres desde el objeto Taxonomía guardado (TXNivel1…7 consecutivos no vacíos). */
  private leerRutaTaxonomiaDesdePayload(
    t: TipoBonoTaxonomia | undefined | null
  ): string[] {
    if (!t) {
      return [];
    }
    const ext = t as Record<string, unknown>;
    const path: string[] = [];
    for (let i = 1; i <= this.maxTaxoNiveles; i++) {
      const key = `TXNivel${i}`;
      const v = ext[key];
      const s = v != null ? String(v).trim() : "";
      if (s === "") {
        break;
      }
      path.push(s);
    }
    return path;
  }

  /**
   * Hoja efectiva para Revenue / Cuenta visitante: fusiona datos del GET tipo bono cuando
   * GetTXItemVentasSegunNivel no los trae o el TXItemVentasId del payload no coincide con la hoja.
   */
  private getTaxoItemHojaParaVista(): TxItemVentasNivel | null {
    const leaf = this.getTaxoItemHoja();
    if (!leaf) {
      return null;
    }
    const snap = this.taxoSnapshotInformacion;
    if (!snap) {
      return leaf;
    }
    const idLeaf = String(leaf.TXItemVentasId ?? "").trim();
    const idSnap = snap.txItemVentasId;
    const coincideId =
      idLeaf !== "" && idSnap !== "" && idLeaf === idSnap;
    const fusionar =
      coincideId ||
      (this.taxoHydratedFromPayloadLevels && idLeaf !== "");
    if (!fusionar) {
      return leaf;
    }
    const tieneRcLeaf =
      leaf.RevenueCategory != null &&
      String(leaf.RevenueCategory).trim() !== "";
    const nLeaf = this.taxoLeerCuentaVisitanteNumerico(leaf);
    const tieneCvLeaf = !Number.isNaN(nLeaf) && nLeaf > -1;
    return {
      ...leaf,
      RevenueCategory: tieneRcLeaf
        ? leaf.RevenueCategory
        : snap.revenueCategory ?? leaf.RevenueCategory,
      CuentaVisitante: tieneCvLeaf
        ? leaf.CuentaVisitante
        : snap.cuentaVisitante ?? leaf.CuentaVisitante,
    };
  }

  private async buscarRutaTaxonomiaPorTxItemId(
    targetId: string
  ): Promise<string[] | null> {
    const walk = async (
      pathSoFar: string[],
      level: number
    ): Promise<string[] | null> => {
      if (level > this.maxTaxoNiveles) {
        return null;
      }
      const pred =
        level === 1 ? "" : pathSoFar[pathSoFar.length - 1];
      const data = await this.servicioAPI
        .getTXItemVentasSegunNivel(level, pred)
        .pipe(take(1))
        .toPromise();
      const list = this.mapListadoTxItems(data?.DatosResult?.Listado);
      if (!list.length) {
        return null;
      }
      for (const item of list) {
        const succ = this.tieneSucesorTaxo(item);
        const txId = String(item.TXItemVentasId ?? "");
        if (!succ && txId === targetId) {
          return [...pathSoFar, item.NivelNombre];
        }
        if (succ) {
          const sub = await walk(
            [...pathSoFar, item.NivelNombre],
            level + 1
          );
          if (sub) {
            return sub;
          }
        }
      }
      return null;
    };
    return walk([], 1);
  }

  private async hidratarTaxonomiaNivelesDesdeTxItemId(
    targetId: string
  ): Promise<void> {
    this.taxoMontandoNiveles = true;
    this._cds.detectChanges();
    const path = await this.buscarRutaTaxonomiaPorTxItemId(targetId);
    if (!path?.length) {
      this.taxoMontandoNiveles = false;
      this.reiniciarTaxonomiaNivelesDesdeCero();
      this._cds.detectChanges();
      return;
    }
    await this.aplicarRutaTaxonomiaNiveles(path, false);
  }

  private async hidratarTaxonomiaNivelesDesdeRuta(
    path: string[]
  ): Promise<void> {
    if (!path?.length) {
      this.reiniciarTaxonomiaNivelesDesdeCero();
      return;
    }
    await this.aplicarRutaTaxonomiaNiveles(path, true);
  }

  private async aplicarRutaTaxonomiaNiveles(
    path: string[],
    hidratoDesdePayload: boolean
  ): Promise<void> {
    const fa = this.taxoNiveles;
    if (!fa) {
      return;
    }
    this.taxoMontandoNiveles = true;
    this._cds.detectChanges();
    this.taxoIgnorarCambioNivel = true;
    while (fa.length) {
      fa.removeAt(0);
    }
    this.taxoNivelOpciones = [];
    this.taxoNivelSeleccionMeta = [];
    try {
      const requests = path.map((_, i) => {
        const level = i + 1;
        const pred = i === 0 ? "" : path[i - 1];
        return this.servicioAPI
          .getTXItemVentasSegunNivel(level, pred)
          .pipe(take(1))
          .toPromise();
      });
      let results: any[];
      try {
        results = await Promise.all(requests);
      } catch {
        this.reiniciarTaxonomiaNivelesDesdeCero();
        return;
      }
      for (let i = 0; i < path.length; i++) {
        const list = this.mapListadoTxItems(results[i]?.DatosResult?.Listado);
        this.taxoNivelOpciones.push(list);
        let item =
          list.find((x) => x.NivelNombre === path[i]) || null;
        if (i === path.length - 1 && item) {
          item = { ...item, TieneSucesor: 0 };
        }
        this.taxoNivelSeleccionMeta.push(item);
        fa.push(this.formBuilder.control(path[i], Validators.required));
      }
      this.taxoHydratedFromPayloadLevels = hidratoDesdePayload;
    } finally {
      this.taxoIgnorarCambioNivel = false;
      this.taxoMontandoNiveles = false;
      this._cds.detectChanges();
    }
  }

  private buildTaxonomiaPayload(): TipoBonoTaxonomia | null {
    const leaf = this.getTaxoItemHoja();
    if (!leaf) {
      return null;
    }
    const ccPk = this.taxoResolverPkDesdeLista(
      this.listaTxCentroCoste,
      this.f["taxoCentroCosteId"]?.value
    );
    const tpPk = this.taxoResolverPkDesdeLista(
      this.listaTxTipoPrecio,
      this.f["taxoTipoPrecioId"]?.value
    );
    const cvPk = this.taxoResolverPkDesdeLista(
      this.listaTxCanalVentas,
      this.f["taxoCanalVentasId"]?.value
    );
    if (ccPk == null || tpPk == null || cvPk == null) {
      return null;
    }
    const tax: TipoBonoTaxonomia = {
      TXCentroCosteId: Number(ccPk) || ccPk,
      TXCanalVentasId: Number(cvPk) || cvPk,
      TXTipoPrecioId: Number(tpPk) || tpPk,
      TXItemVentasId: Number(leaf.TXItemVentasId) || leaf.TXItemVentasId,
    };
    const faN = this.taxoNiveles;
    if (faN?.length) {
      for (let i = 0; i < this.maxTaxoNiveles; i++) {
        const ctl = faN.at(i);
        const v = ctl?.value;
        const s = v != null ? String(v).trim() : "";
        const key = `TXNivel${i + 1}` as keyof TipoBonoTaxonomia;
        (tax as any)[key] = s;
      }
    }
    const leafVista = this.getTaxoItemHojaParaVista();
    if (
      leafVista?.RevenueCategory != null &&
      String(leafVista.RevenueCategory).trim() !== ""
    ) {
      tax.RevenueCategory = String(leafVista.RevenueCategory);
    }
    const nCv = leafVista
      ? this.taxoLeerCuentaVisitanteNumerico(leafVista)
      : NaN;
    if (!Number.isNaN(nCv) && nCv > -1 && leafVista) {
      tax.CuentaVisitante = leafVista.CuentaVisitante;
    }
    if (
      this.taxoTXAlojamientoIdPendiente != null &&
      String(this.taxoTXAlojamientoIdPendiente).trim() !== ""
    ) {
      tax.TXAlojamientoId =
        Number(this.taxoTXAlojamientoIdPendiente) ||
        this.taxoTXAlojamientoIdPendiente;
    }
    return tax;
  }

  private limpiarCamposFormularioTaxonomiaDelPayload(b: any): void {
    delete b.taxoCentroCosteId;
    delete b.taxoTipoPrecioId;
    delete b.taxoCanalVentasId;
    delete b.taxoNiveles;
  }

  /** Solo aplica si `mostrarTaxonomia` (GetAppConfig Taxonomia = 1); si no, no bloquea guardado ni marcamos taxo*. */
  private validarTaxonomiaParaGuardar(): boolean {
    if (!this.mostrarTaxonomia) {
      return true;
    }
    this.f["taxoCentroCosteId"]?.markAsTouched();
    this.f["taxoTipoPrecioId"]?.markAsTouched();
    this.f["taxoCanalVentasId"]?.markAsTouched();
    this.taxoNiveles?.controls.forEach((c) => c.markAsTouched());
    if (
      !this.f["taxoCentroCosteId"]?.value ||
      !this.f["taxoTipoPrecioId"]?.value ||
      !this.f["taxoCanalVentasId"]?.value
    ) {
      return false;
    }
    const fa = this.taxoNiveles;
    if (!fa?.length) {
      return false;
    }
    for (let i = 0; i < fa.length; i++) {
      const v = fa.at(i).value;
      if (!v || String(v).trim() === "") {
        return false;
      }
    }
    if (
      this.taxoResolverPkDesdeLista(
        this.listaTxCentroCoste,
        this.f["taxoCentroCosteId"]?.value
      ) == null ||
      this.taxoResolverPkDesdeLista(
        this.listaTxTipoPrecio,
        this.f["taxoTipoPrecioId"]?.value
      ) == null ||
      this.taxoResolverPkDesdeLista(
        this.listaTxCanalVentas,
        this.f["taxoCanalVentasId"]?.value
      ) == null
    ) {
      return false;
    }
    return this.getTaxoItemHoja() != null;
  }

  cargarDatos() {
    //Cargamos Datos
    let resultado: boolean = false;

    this.BonoTypeService.getGruposTiposEntrada().subscribe(
      (data) => {
        this.GrupoMotivosId = data.DatosResult.customanGrupoTipoEntrada.filter(
          (filter) => filter.ConMotivo == 1
        );
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetGrupoTipoBono().subscribe(
      (data) => {
        this.gruposTipoBono = data.DatosResult.customanGrupoTipoBono;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetTiposProductos().subscribe(
      (data) => {
        this.gruposTiposProductos = [];
        if (data.DatosResult)
          this.gruposTiposProductos = data.DatosResult.ListadoTiposProductos;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetGruposAsociados().subscribe(
      (data) => {
        this.gruposAsociados = [];
        if (data.DatosResult)
          this.gruposAsociados = data.DatosResult.ListadoGruposAsociados;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetTipoVisitas().subscribe(
      (data) => {
        this.tiposvisitas = [];
        if (data.DatosResult) this.tiposvisitas = data.DatosResult.lista;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetTipoNiveles().subscribe(
      (data) => {
        this.tiposnivel = [];
        if (data.DatosResult)
          this.tiposnivel = data.DatosResult.ListadoTiposNiveles;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetCategorias().subscribe(
      (data) => {
        this.categoriaDatos = data.DatosResult.lista;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetTEDatos().subscribe(
      (data) => {
        if (data.DatosResult)
          this.TEDatos = data.DatosResult.ListadoTiposEntradaDatos;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.BonoTypeService.GetTipoEntrada().subscribe(
      (data) => {
        this.tiposEntrada = data.DatosResult.Lista;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.cargarCanales();
    this.manageForm(this.pkId, this.mode);
    return resultado;
  }

  async cargarBotonera(): Promise<boolean> {
    let resultado: boolean = false;
    await this.BonoTypeService.getBotoneraAsync(
      null,
      this.global.maxBotonesRapidosTPV.toString().trim()
    ).then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposBotoneraEntrada = data.DatosResult.Lista;
        } else {
          this.alertaServicio.error(
            "Botonera: " + data.Mensajes[0].DescripcionMensaje
          );
          resultado = false;
        }
      },
      (error) => {
        //this.alertaServicio.error('Botonera: ' + error);
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    return resultado;
  }

  CambioTeclaRapida(ev) {
    let v = ev.value;
    let c = this.tiposBotoneraEntrada.find((f) => f.TeclaRapida == v);
    if (c && c.NombreTipo.trim() != "")
      this.f["chTeclaRapida"].setValue(this.bonoType.chTeclaRapida);
  }

  iValidezaCero(ev, form) {
    if (ev.value) form.patchValue({ iValidez: 0 });
  }

  cambiaNombre(evento) {
    //Si los modelos de Display, Taquilla y Imprimir estan vacios les pongo el nombre del evento.

    if (
      this.f["chTextoDisplay"].value == null ||
      this.f["chTextoDisplay"].value.trim() == ""
    ) {
      this.f["chTextoDisplay"].setValue(evento.target.value);
    }
    if (
      this.f["chTextoPantalla"].value == null ||
      this.f["chTextoPantalla"].value.trim() == ""
    ) {
      this.f["chTextoPantalla"].setValue(evento.target.value);
    }
    if (
      this.f["chTextoImpresion"].value == null ||
      this.f["chTextoImpresion"].value.trim() == ""
    ) {
      this.f["chTextoImpresion"].setValue(evento.target.value);
    }
  }
  comparaObjetosSelect(o1: any, o2: any) {
    return o1 && o2
      ? o1.id === o2.id || o1 === o2.id || o1.id === o2
      : o1 === o2;
  }

  validacion() {
    const separador = document.getElementsByClassName("separadorLateral");
    const campos = document.getElementsByClassName("editor-campo-registro");
    for (let i = 0; i < campos.length; i++) {
      if (campos[i].classList.contains("ng-valid")) {
        if (campos[i].classList.contains("editor-campo-registro-check")) {
          separador[i].setAttribute("style", "border-color:#002c76");
        } else {
          separador[i].setAttribute("style", "border-color:green");
        }
      } else {
        separador[i].setAttribute("style", "border-color:#002c76");
      }
    }
  }

  // formato front: 2020-10-14 (yyyy-mm-dd)
  // formato back:  31/12/2900 0:00:00 (dd/mm/yyyy 0:00:00)
  fechaApiToFechaFront(fecha: string) {
    if (fecha) {
      let split1 = fecha.split(" ");
      let split2 = split1[0].split("/");
      let ans = split2[2] + "-" + split2[1] + "-" + split2[0];
      return ans;
    } else {
      return fecha;
    }
  }

  fechaFrontToFechaApi(fecha: string) {
    let split1 = fecha.split("-");
    let ans = split1[2] + "/" + split1[1] + "/" + split1[0] + " 0:00:00";
    return ans;
  }

  fechaFrontToFechaApiTable(fecha: string) {
    let ans = fecha + " 0:00:00";
    return ans;
  }

  cabgetNombreGrupoById(id: string) {
  }

  isnovalid() {}

  validateTable(promocionEntradaFormGroup) {
    let ret = true;
    if (this.hasTableRows()) {
      if (promocionEntradaFormGroup)
        promocionEntradaFormGroup.controls.forEach((element) => {
          if (
            element instanceof FormGroup &&
            element.value["iTipoEntradaId"] == ""
          )
            ret = false;
          if (
            element instanceof FormGroup &&
            element.value["iNumEntradas"] == ""
          )
            ret = false;
          if (
            element instanceof FormGroup &&
            element.value["dtFechaInicio"] == ""
          )
            ret = false;
          if (element instanceof FormGroup && element.value["dtFechaFin"] == "")
            ret = false;
        });
    } else {
      ret = false;
    }
    return ret;
  }

  hasTableRows() {
    let ret = false;
    if (
      !this.promocionEntradaFormGroup ||
      this.promocionEntradaFormGroup.length < 1
    )
      ret = false;
    else ret = true;

    return ret;
  }

  getCanalIdParaData(): string {
    const ctrl = this.editorRegistroForm.get('canalId');
    if (ctrl && ctrl.value != null) return ctrl.value;
    if (this.bonoType) return this.bonoType.canalId != null ? this.bonoType.canalId : (this.bonoType.CanalId || '');
    return '';
  }

  closeInputFilter(enventValues) {
    this.editorRegistroForm.get(enventValues.name).setValue(enventValues.value);
  }

  closeInputFilterInArray(enventValues, i) {
    this.editorRegistroForm.controls["Entradas"]["controls"][i]
      .get("iTipoEntradaId")
      .setValue(enventValues.value);
    this.editorRegistroForm.controls["Entradas"]["controls"][i]
      .get("iTipoBonoEntradasId")
      .setValue(enventValues.value);
  }

  callbacksOnGrupoId(event: any) {
    this.markFormAsInvalid = event.methods.markFormAsInvalid;
  }

}
